var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewMode)?_c('CRow',{staticClass:"form-group"},[_c('CCol',[_c('p',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticStyle:{"display":"flex"}},[_c('p',{staticClass:"staff_name"},[_vm._v(_vm._s(_vm.staffName))])])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }